// The embedded hunter host is env-driven so test/staging/prod can differ without a
// code change. See VITE_HUNTER_URL in the .env files. Shared by the web iframe embed
// and the native (iOS WKWebView / Android TWA HunterActivity) full-screen webview openers.
export const HUNTER_URL =
  import.meta.env.VITE_HUNTER_URL || "https://test-hunter.mo.one/";
